import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import React from "react";
/**
 * Custom group renderer for AgGrid in Viewport mode.
 * This is basic implementation, it doesnt have as much features as default groupCellRenderer.
 * If you need more features FIY, you can look at ag-grid-community/src/ts/cellRenderers/groupCellRenderer.ts for reference.
 * More information about custom cell renderers can also be found in official AgGrid docs.
 *
 * NOTE: keep in mind you have to provide all parameters for this component in order to make it work correctly.
 * TODO: register additional handlers for toggle ( on dbl click, on enter key press )
 */

export var ViewportGroupCellRenderer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ViewportGroupCellRenderer, _React$Component);

  function ViewportGroupCellRenderer(props) {
    var _this;

    _classCallCheck(this, ViewportGroupCellRenderer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ViewportGroupCellRenderer).call(this, props));

    _this.setBaseParams(props);

    _this.onToggle = _this.onToggle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(ViewportGroupCellRenderer, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setBaseParams(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.value) {
        return React.createElement("span", null, React.createElement("span", {
          style: {
            display: "inline-block",
            transform: "translate(0, 3px)",
            marginRight: 4
          },
          className: "ag-loading-icon"
        }, React.createElement("span", {
          className: "ag-icon ag-icon-loading",
          unselectable: "on"
        })), React.createElement("span", {
          className: "ag-loading-text"
        }, "Loading"));
      }

      return React.createElement("span", {
        className: "ag-row-group-indent-".concat(this.groupLevelIndent)
      }, this.isGroup && (this.isExpanded ? React.createElement("span", {
        className: "ag-group-expanded",
        onClick: this.onToggle
      }, React.createElement("span", {
        className: "ag-icon ag-icon-contracted",
        unselectable: "on"
      })) : React.createElement("span", {
        className: "ag-group-contracted",
        onClick: this.onToggle
      }, React.createElement("span", {
        className: "ag-icon ag-icon-expanded",
        unselectable: "on"
      }))), React.createElement("span", {
        className: "ag-group-value"
      }, this.props.value));
    }
    /** Sets base params from props */

  }, {
    key: "setBaseParams",
    value: function setBaseParams(props) {
      this.baseParams = {
        node: props.node,
        data: props.data,
        colDef: props.colDef,
        column: props.column,
        api: props.api,
        columnApi: props.columnApi,
        context: props.context
      };
    } // private onCellDblClicked(mouseEvent: MouseEvent) {
    //   if (GridUtils.isStopPropagationForAgGrid(mouseEvent)) { return; }
    //
    //   // we want to avoid acting on double click events on the expand / contract icon,
    //   // as that icons already has expand / collapse functionality on it. otherwise if
    //   // the icon was double clicked, we would get 'click', 'click', 'dblclick' which
    //   // is open->close->open, however double click should be open->close only.
    //   const targetIsExpandIcon
    //     = GridUtils.isElementInEventPath(this.eExpanded, mouseEvent)
    //     || GridUtils.isElementInEventPath(this.eContracted, mouseEvent);
    //
    //   if (!targetIsExpandIcon) {
    //     this.onToggle();
    //   }
    // }

    /** Unifies isGroup calling */

  }, {
    key: "onToggle",
    value: function onToggle() {
      var groupId = this.props.groupId ? this.props.groupId(this.baseParams) : undefined;

      if (groupId && this.props.onToggle) {
        this.props.onToggle(groupId);
      }
    }
  }, {
    key: "isGroup",
    get: function get() {
      return this.props.isGroup && this.props.isGroup(this.baseParams);
    }
    /** Unifies isExpanded calling */

  }, {
    key: "isExpanded",
    get: function get() {
      return this.props.isExpanded && this.props.isExpanded(this.baseParams);
    }
    /** Unifies groupLevel calling */

  }, {
    key: "groupLevel",
    get: function get() {
      return this.props.groupLevel ? this.props.groupLevel(this.baseParams) : 0;
    }
    /** Unifies groupLevel calling */

  }, {
    key: "groupLevelIndent",
    get: function get() {
      var increese = this.isGroup ? 1 : 2;
      return this.props.groupLevel ? this.props.groupLevel(this.baseParams) - 2 + increese : 0;
    }
  }]);

  return ViewportGroupCellRenderer;
}(React.Component);